import { connect } from 'react-redux'
import Polls from './Polls'

const mapStateToProps = (state) => ({
	polls: Object.values(state.polls).sort((a, b) => (
		a.ts > b.ts ? -1 : 1
	)),
	results: state.results,
})

const Container = connect(
  mapStateToProps,
)(Polls)

export default Container



// WEBPACK FOOTER //
// ./src/components/polls/Container.jsx